import React from 'react';
import './App.css';

const Team = () => {
  // --- TEAM ---
  const teamMembers = [
    {
      name: "Norman",
      title: "President & Founder",
      bio: "Former strategy consultant with 15 years of experience leading digital transformations for Fortune 500 financial institutions through Exia Group.",
      image: "/headshots/president.jpeg"
    },
    {
      name: "Christina",
      title: "Analytics Intern",
      bio: "Expert in AI implementation and operational efficiency. Christina leads our global technology practice.",
      image: "/headshots/Christina.jpeg"
    },  
    {
      name: "Astin",
      title: "Software Engineer Intern",
      bio: "Astin is a full-stack web developer at Exia group, known for his versatility and creativity. Starting his programming joruney in High school, Astin has built a solid foundation in high demand technology stacks. Currently pursuing a computer science and mathemathical degree at Rutgers University, he focuses on enhancing his knowledge in web development and artificial intelligence.",
      image: "/headshots/Astin.jpg"
    }
  ];

  return (
    <div className="page-fade-in">
      
      {/* Page Header */}
      <div className="container" style={{paddingTop: '6rem', paddingBottom: '4rem'}}>
        <h1 style={{fontSize: '4rem', fontWeight: '800', marginBottom: '1rem'}}>
          Our Leadership.
        </h1>
        <p style={{fontSize: '1.5rem', color: '#a1a1a1', maxWidth: '800px'}}>
          Meet the minds behind the methodology.
        </p>
      </div>

      {/* Team Grid */}
      <div className="container" style={{paddingBottom: '6rem'}}>
        <div className="grid-3" style={{borderTop: 'none', borderLeft: 'none'}}>
          
          {teamMembers.map((member, index) => (
            <div key={index} style={{marginBottom: '4rem'}}>
              
              {/* Headshot Image Container */}
              <div style={{
                height: '450px', 
                backgroundColor: '#1a1a1a', 
                marginBottom: '1.5rem',
                overflow: 'hidden',
                position: 'relative'
              }}>
                <img 
                  src={member.image} 
                  alt={member.name} 
                  style={{
                    width: '100%', 
                    height: '100%', 
                    objectFit: 'cover',
                    filter: 'grayscale(20%) contrast(110%)'
                  }} 
                />
              </div>

              {/* Text Info */}
              <h3 style={{
                fontSize: '2rem',
                marginBottom: '0.5rem', 
                fontWeight: '700', 
                marginLeft: '.5rem'
              }}>
                {member.name}
              </h3>
              
              <span style={{
                color: '#00a40e',
                fontWeight: '700', 
                textTransform: 'uppercase', 
                fontSize: '0.9rem',
                display: 'block',
                marginBottom: '1rem',
                marginLeft: '.5rem'
              }}>
                {member.title}
              </span>

              <p style={{
                color: '#a1a1a1', 
                lineHeight: '1.6', 
                maxWidth: '90%', 
                marginLeft: '.5em'
              }}>
                {member.bio}
              </p>
            </div>
          ))}

        </div>
      </div>
    </div>
  );
};

export default Team;